import ApiErrorResponse from "@eryxcoop/appyx-comm/src/responses/generalResponses/ApiErrorResponse";

export default class EditLeadStageErrorResponse extends ApiErrorResponse {
    static defaultResponse() {
        return {
            object: {},
            errors: [{
                code: 'lead_cannot_be_manually_moved_to_the_stage',
                text: 'El lead no puede pasarse manualmente a la etapa indicada',
            }],
        };
    }

    static errorCodes() {
        return ['lead_cannot_be_manually_moved_to_the_stage', 'user_does_not_have_required_permission_error'];
    }
}
